import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { changeLanguage, subscribeLocaleBroadcast } from '@/lib/i18n';
import { SegmentedControl } from '@/components/ui/SegmentedControl';
import { SettingsSection } from '@/components/settings/SettingsSection';

export function LanguageSection() {
  const { t, i18n } = useTranslation();
  const [lng, setLng] = useState(i18n.language);

  useEffect(() => subscribeLocaleBroadcast(setLng), []);

  return (
    <SettingsSection id="settings-language" title={t('settings.language')}>
      <SegmentedControl
        className="max-w-xs"
        aria-label={t('settings.language')}
        items={[
          { id: 'en', label: t('settings.english') },
          { id: 'ar', label: t('settings.arabic') }
        ]}
        value={lng.startsWith('ar') ? 'ar' : 'en'}
        onChange={(id) => changeLanguage(id as 'en' | 'ar')}
      />
    </SettingsSection>
  );
}
